import { useEffect, useState } from "react";

const useScript = (scriptParams: { url: string; async: boolean }) => {
  const [isInit, setIsInit] = useState(false);
  const { url, async } = scriptParams;

  //@ts-ignore
  var PUBLIC_URL = url;

  useEffect(() => {
    console.log("useScript", url, isInit);
    if (isInit) return;
    let script;
    script = document.createElement("script");
    script.src = url;
    script.async = async;
    script.onload = () => {
      setIsInit(true);
    };
    document.body.appendChild(script);

    return () => {
      console.log("useScript cleanup", url);
      script && document.body.removeChild(script);
    };
  }, [url]);

  return { isInit };
};

export default useScript;
